import { themeVars } from '../theme/vars.ts';
import { space } from '../tokens.ts';
import { typography } from '../typography.ts';
import { globalStyle, style } from '../layer.css';

export const avatarGroupContainer = style({
  display: 'flex',
  gap: space.s8,
  alignItems: 'center',
});

export const avatarGroup = style({
  display: 'flex',
  direction: 'rtl',
});

globalStyle(`${avatarGroup} > :not(:last-child)`, {
  marginLeft: `-${space.s16}px`,
});

export const additionalInfo = style({
  ...typography['bodySm'],

  color: themeVars.container.foreground.tertiary,
});
